import GraphContent from "../graph_content";
import axios from "axios";
import { RequestParamsMaker } from "./make_request_params";

/**
 * 認証情報をLambdaへ送る
 * @param self グラフコンテンツ
 */
export async function getTableKeySchema(self: GraphContent) {
  try {
    // リクエスト情報の生成
    const requestParams = RequestParamsMaker.makeKeySchemaParams(self);
    // APIの実行
    const apiResponse = await axios(requestParams);
    // `graph_content.ts`内の変数に代入
    const res = apiResponse.data.res;
    // TODO: APIを修正したのち、修正する
    self.partitionKey = res.partitionKey;
    self.partitionKeyType = res.partitionKeyType;
    self.sortKey = res.sortKey;
    self.sortKeyType = res.sortKeyType;
    self.tableName = self.inputTableName;
    self.partitionAndSortError = "";
    return;
  } catch (e) {
    console.error(e);
    self.partitionAndSortError = e.response.data.error;
    return;
  }
}
